import { Component, OnInit } from "@angular/core";
import { VisitService } from "./../services/visit.service";
import { forkJoin } from "rxjs/internal/observable/forkJoin";
import { EngineService } from "./../services/engine.service";
import { SpinnerService } from "./../services/spinner.service";
import { AuthService } from "../services/auth.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  constructor(
    private visitService: VisitService,
    private engineService: EngineService,
    private spinnerService: SpinnerService,
    private authService: AuthService
  ) {}
  orderData: any = [];
  calledPowerCoatchData: any = [];
  powerCoachEngineDifferenceData: any = [];
  ngOnInit() {
    this.initData();
  }

  initData() {
    this.spinnerService.show();
    forkJoin([
      this.getDoneOrder(),
      this.getNonDoneOrder(),
      this.getReminderedOrder(),
      this.getEngineDifferenceForAPowerCoach(),
      this.getWantedPowerCoach(),
    ]).subscribe((results: any) => {
      let orderList = [];
      orderList.push({
        name: "مكتمل",
        value: results[0].count,
      });
      orderList.push({
        name: "معلق",
        value: results[1].count,
      });
      orderList.push({
        name: "تم تخطيها",
        value: results[2].count ? results[2].count : 0,
      });
      this.orderData = [...orderList];
      const diffList = results[3];
      this.powerCoachEngineDifferenceData = [...diffList];
      this.calledPowerCoatchData = [...results[4]];
      this.spinnerService.hide();
    });
  }

  getDoneOrder() {
    return this.visitService.getDoneOrdersCount();
  }

  getNonDoneOrder() {
    return this.visitService.getUnDoneOrdersCount();
  }

  getReminderedOrder() {
    return this.visitService.getReminderedOrdersCount();
  }

  getEngineDifferenceForAPowerCoach() {
    return this.engineService.getEngineDifferenceForAPowerCoach();
  }

  getWantedPowerCoach() {
    return this.engineService.getWantedPowerCoach();
  }
}
